import type { HttpClient } from '@angular/common/http';
import type { HomeSeries } from '@thevillages/schemas';

import type { AvailableSeriesParamsType } from '../available-series';

import { Environment } from '../../../../environments/environment';
import { AddQueryParams } from '../../../utils/add-query-params';
import { GetRequest } from '../../../utils/get-request';

export async function SeriesLoader(
  http: HttpClient,
  params: AvailableSeriesParamsType,
): Promise<HomeSeries[]> {
  const _base = `${Environment.apiUrl}/series`;
  const _url = params.id ? `${_base}/${params.id}` : AddQueryParams(_base, params);

  return GetRequest<HomeSeries[]>(http, _url, { priority: 'low' });
}
